import React from "react";

import SipPage from "../SipPage";
import { beautyMeta, beauty } from "../variables";

const Beauty: React.FC = () => <SipPage meta={beautyMeta} section={beauty} />;

export default Beauty;
